import { Event } from "~/api/resources/Events";
import { BaseMap } from "./BaseMap";
import { useBreakpointValue } from "@chakra-ui/react";
import { findIndex } from "lodash";
import {
  getBoundsFromLonLats,
  getMarkerIcon,
  getPositionFromLonLat,
} from "./helpers";
import { InfoWindowF, MarkerF } from "@react-google-maps/api";
import { LocationMarker } from "./Markers";

type Props = {
  event: Event;
};

export const EventMap = ({ event }: Props) => {
  const borderRadius = useBreakpointValue({ base: 60, lg: 100 });
  const locations = event.event_times
    .flatMap((et) => et.locations ?? [])
    .filter(
      (location, index, allLocations) =>
        !!location &&
        !!location.lonlat &&
        findIndex(allLocations, { id: location.id }) === index,
    );
  if (!locations.length || !locations[0].lonlat) return null;
  return (
    <BaseMap
      options={{ fullscreenControl: false }}
      center={getPositionFromLonLat(locations[0].lonlat)}
      mapContainerStyle={{
        height: "70vh",
        borderBottomLeftRadius: borderRadius,
        borderTopRightRadius: borderRadius,
        overflow: "hidden",
      }}
      onLoad={(map) => {
        if (locations.length > 1) {
          const bounds = getBoundsFromLonLats(
            locations.filter((location) => !!location.lonlat) as Array<{
              lonlat: string;
            }>,
          );
          map.fitBounds(bounds);
        }
      }}
    >
      {locations.map((location) => (
        <LocationMarker key={location.id} location={location} />
      ))}
    </BaseMap>
  );
};
